import {
  FETCH_HOUSE_LIST,
  FETCH_PHOTOGRAPHY_COST,
  PAYMENT_PHOTOGRAPHY,
} from '../actions/types'
export interface houseCostInfo {
  main: number
  room: number
}
export interface houseType {
  apartment: houseCostInfo
  boomgardi: houseCostInfo
  villa: houseCostInfo
}
export interface houseCostType {
  prices: houseType
  discount: number
}
export interface PhotographyCost {
  data: houseCostType | null
  loading: boolean
}
export const photographyCost = (
  state: PhotographyCost = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_PHOTOGRAPHY_COST:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
export interface HouseInfo {
  id: number
  cover: { thumbnailAbsoluteUrl: string }
  title: string
  room: number
}
export interface HouseList {
  data: HouseInfo[]
  loading: boolean
}
export const houseList = (
  state: HouseList = { data: [], loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_HOUSE_LIST:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface PaymentData {
  payType: number
  houseIds: number[]
}
export interface PaymentPhotography {
  data: PaymentData
  loading: boolean
}
export const paymentPhotography = (
  state: PaymentPhotography = {
    data: { payType: 0, houseIds: [] },
    loading: false,
  },
  action,
) => {
  switch (action.type) {
    case PAYMENT_PHOTOGRAPHY:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
